import React from 'react';

class ChatterMessage extends React.Component {
  render() {
    const { fromMe, message } = this.props;

    return (
      <div className="chat-message clearfix">
        <div className={'chat-bubble ' + (fromMe ? 'from-me ' : '') + (!fromMe ? 'from-them ' : '')}>
          {message.message}
        </div>
      </div>
    );
  }
}
ChatterMessage.defaultProps = {
  fromMe: false,
};

export default ChatterMessage;
